/*  UPDATE ➜  assets/shipping-estimator.js  */
/*  --------  CORRIGIDO: inclui UF → província e usa shipping_address.zip  */
(() => {
    const moneyFmt = window.moneyFormat || '${{amount}}';
    const fmt = c =>
        moneyFmt
            .replace('{{amount}}', (c / 100).toFixed(2).replace('.', ','))
            .replace('{{ amount }}', (c / 100).toFixed(2).replace('.', ','));

    /* UF ➜ nome de província reconhecido pela Shopify */
    const UF_MAP = {
        AC: 'Acre', AL: 'Alagoas', AP: 'Amapa', AM: 'Amazonas', BA: 'Bahia',
        CE: 'Ceara', DF: 'Distrito Federal', ES: 'Espirito Santo', GO: 'Goias',
        MA: 'Maranhao', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul',
        MG: 'Minas Gerais', PA: 'Para', PB: 'Paraiba', PR: 'Parana',
        PE: 'Pernambuco', PI: 'Piaui', RJ: 'Rio de Janeiro',
        RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondonia',
        RR: 'Roraima', SC: 'Santa Catarina', SP: 'Sao Paulo', SE: 'Sergipe',
        TO: 'Tocantins'
    };

    /* Consulta ViaCEP para descobrir a UF e converter para província */
    async function getProvinceFromCEP(cep) {
        try {
            const data = await fetch(`https://viacep.com.br/ws/${cep}/json/`).then(r => r.json());
            if (data.erro) return null;
            return UF_MAP[data.uf] || null;
        } catch (e) {
            console.error('ViaCEP error', e);
            return null;
        }
    }

    const init = root => {
        const form = root.querySelector('[data-shipping-form]');
        const zip = root.querySelector('[data-zip]');
        const out = root.querySelector('[data-shipping-result]');
        const btn  = root.querySelector('[data-calc-shipping]');   
        
        btn.addEventListener('click', async e => {
            e.preventDefault();
            out.textContent = 'Calculando…';
            const cep = zip.value.replace(/\D/g, '');

            if (cep.length !== 8) {
                out.textContent = 'CEP inválido';
                return;
            }

            /* --> NOVO: obter província a partir do CEP */
            const province = await getProvinceFromCEP(cep);
            if (!province) {
                out.textContent = 'CEP não encontrado';
                return;
            }

            try {
                /* 1. prepara cálculo */
                const prepRes = await fetch('/cart/prepare_shipping_rates.json', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        shipping_address: {
                            zip: cep,
                            country: 'Brazil',
                            province: province
                        }
                    })
                });

                if (!prepRes.ok) throw new Error(`Status ${prepRes.status}`);

                /* 2. poll até rates prontos */
                let rates;
                for (let i = 0; i < 6; i++) {
                    await new Promise(r => setTimeout(r, 600));
                    rates = await fetch('/cart/async_shipping_rates.json')
                        .then(r => r.json());
                    if (rates.shipping_rates) break;
                }

                if (!rates.shipping_rates || !rates.shipping_rates.length) {
                    out.innerHTML = '<p>Não foi possível calcular o frete.</p>';
                    return;
                }

                /* ---------- NOVO BLOCO ---------- */
                const rows = rates.shipping_rates.map(rate => {
                    const days = Array.isArray(rate.delivery_days) && rate.delivery_days.length
                        ? Math.max(...rate.delivery_days)
                        : null;
                    const estimate = rate.description
                        ? rate.description
                        : days ? `Até ${days} dias úteis`
                            : 'Estimativa indisponível';
        
                    let shippingPrice = rate.price ? `R$ ${rate.price.replace('.', ',')}` : 'R$ 0,00';

                    return `
                            <div class="shipping-item">
                            <span><strong>${rate.name}</strong> — ${estimate}</span>
                            <strong>${shippingPrice}</strong>
                            </div>`;
                                        }).join('');

                    out.innerHTML = `${rows}`
    
            } catch (err) {
                console.error(err);
                out.textContent = 'Erro ao calcular o frete.';
            }
        });
    };

    document.querySelectorAll('[data-shipping-root]').forEach(init);
})();
